export default "__VITE_ASSET__DP8UX$lb__"